import React from "react";

import createBaseRenderer from "./createBaseRenderer";

export default function createCsEnRenderer(key) {
  return createBaseRenderer({
    name: "csEnRenderer",
    placeholderText: "lorem ipsum dolor",
    content: ({ val }) => (
      <>
        <div>{val[`${key}Cs`]}</div>
        <div>{val[`${key}En`]}</div>
      </>
    )
  });
}
